export enum REPORT_MODULE_ACTION {
  NONE = 'NONE',
  NEW = 'NEW',
  KEEP = 'KEEP',
  WARNING = 'WARNING',
  WARNED = 'WARNED',
  DELETE = 'DELETE',
  REPORTING = 'REPORTING',
  PENDING = 'PENDING',
  BLOCK = 'BLOCK',
  REJECT = 'REJECT',
  SKIP = 'SKIP',
  SUGGEST = 'SUGGEST',
  APPROVE = 'APPROVE',
  SALES_APPROVE = 'SALES_APPROVE',
  LEGAL_APPROVE = 'LEGAL_APPROVE'
}

export enum REPORT_MODULE_STATUS {
  NONE = 'NONE',
  NEW = 'NEW',
  KEEP = 'KEEP',
  KEPT = 'KEPT',
  DELETE = 'DELETE',
  DELETED = 'DELETED',
  REPORTING = 'REPORTING',
  REPORTED = 'REPORTED',
  WARNING = 'WARNING',
  WARNED = 'WARNED',
  EDITED = 'EDITED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  BLOCK = 'BLOCK',
  EDIT = 'EDIT',
  BLOCKED = 'BLOCKED'
}

export enum OBJECT_TYPE_REPORT {
  POST = 'POST',
  COMMENT = 'COMMENT',
  REPORT = 'REPORT',
  STORY = 'STORY',
  LIVESTREAM = 'LIVESTREAM',
  ADS = 'ADS',
  FANPAGE = 'FANPAGE',
  GROUP = 'GROUP',
  PROFILE = 'PROFILE',
  USERPROFILE = 'USERPROFILE',
  VERIFICATION_REQUEST = 'VERIFICATION_REQUEST',
  BUSINESS_AD_ACCOUNT_VERIFICATION = 'BUSINESS_AD_ACCOUNT_VERIFICATION',
  SHOPRATING = 'SHOPRATING',
  ADVERTISEMENT = 'ADVERTISEMENT',
  MAPPLACE = 'MAPPLACE',
  PRICINGTOUR = 'PRICINGTOUR',
  TOURAGENCY = 'TOURAGENCY',
  TOURRATING = 'TOURRATING',
  TOUR = 'TOUR',
  HOTEL_AGENCY = 'HOTEL_AGENCY',
  HOTELRATING = 'HOTELRATING',
  RESTAURANTRATING = 'RESTAURANTRATING',
  REQUESTSHOP = 'REQUEST_OPEN_SHOP',
  REQUEST_OPEN_SHOP_LEGAL = 'REQUEST_OPEN_SHOP_LEGAL',
  REQUESTRESTAURANT = 'REQUEST_OPEN_RESTAURANT',
  POST_SUGGESTION = 'POST_SUGGESTION',
  TOUR_COMMENT = 'TOUR_COMMENT',
  CAR = 'CAR',
  CARRATING = 'CARRATING',
  REQUEST_OPEN_CAR = 'REQUEST_OPEN_CAR',
  PRODUCT = 'PRODUCT',
  TOUR_LEGAL = 'TOUR_LEGAL',
  CAR_LEGAL = 'CAR_LEGAL',
  HOTEL_LEGAL = 'HOTEL_LEGAL',
  REEL = 'REEL',
  SHOPPING = 'SHOPPING'
}

export enum OBJECT_TYPE_TITLE {
  SHOPRATING_TITLE = 'Shop rating',
  MAPPLACE_TITLE = 'Map place',
  PRICINGTOUR_TITLE = 'Pricing tour',
  TOURAGENCY_TITLE = 'Tour agency',
  TOURRATING_TITLE = 'Tour rating',
  HOTEL_AGENCY_TITLE = 'Hotel agency',
  HOTEL_LEGAL_TITLE = 'Hotel legality',
  HOTELRATING_TITLE = 'Hotel rating',
  RESTAURANTRATING_TITLE = 'Restaurant rating',
  REQUESTSHOP_TITLE = 'Request open shop',
  REQUEST_OPEN_SHOP_LEGAL_TITLE = 'Shopping agency legality',
  REQUESTRESTAURANT_TITLE = 'Request open shop restaurant',
  TOUR_COMMENT = 'Tour comment',
  CAR = 'Car',
  CARRATING = 'Car rating',
  REQUEST_OPEN_CAR = 'Request open car',
  TOUR_TITLE = 'tour',
  LOOP_TITLE = 'Loop',
  CAR_LEGAL_TITLE = 'Car legal',
  TOUR_LEGAL_TITLE = 'Tour legal'
}
